import "./Footer.css";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Linkedin
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

import logo from "../../assets/images/logo/jayaramlog.png";
// import logo2 from "../../assets/images/logo/jayaramSmallLogo.3bb55582.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (e, section) => {
    e.preventDefault();
    const id = section.toLowerCase();

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <img src={logo} alt="Jayram InfraCon" className="footer-logo" />

          <p>
            Jayram Infracon is committed to delivering premium plotted
            developments with legal clarity, prime locations, and
            sustainable living concepts.
          </p>

          {/* SOCIAL ICONS */}
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <Facebook size={18} />
            </a>
            <a href="https://www.instagram.com/jayaram_infracon_pvt_ltd/?hl=en" target="_blank" rel="noopener noreferrer">
              <Instagram size={18} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <a href="/" onClick={(e) => handleScroll(e, "Home")}>Home</a>
          <a href="/" onClick={(e) => handleScroll(e, "About")}>About Us</a>
          <a href="/" onClick={(e) => handleScroll(e, "Projects")}>Projects</a>
          <a href="/" onClick={(e) => handleScroll(e, "Services")}>Services</a>
          <a href="/" onClick={(e) => handleScroll(e, "Contact")}>Contact</a>
          <a href="/" onClick={(e) => handleScroll(e, "Career")}>Career</a>
        </div>

        {/* CONTACT INFO */}
        <div className="footer-contact">
          <h4>Contact Info</h4>

          <div className="footer-item">
            <Phone size={16} />
            <span>+91 7022215439</span>
          </div>

          <div className="footer-item">
            <Mail size={16} />
            <span>info@jayaramgroup.com</span>
          </div>

          <div className="footer-item">
            <MapPin size={16} />
            <span>
              #25, First Floor, Serpentine Road,<br />
              Kumar Park West, Bengaluru - 560020
            </span>
          </div>
        </div>

        {/* PROJECT LOCATIONS */}
<div className="footer-projects">
  <h4>Projects</h4>

  <a href="#">Yelahanka</a>
  <a href="#">Whitefield</a>
  <a href="#">Electronic City</a>
</div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Jayram InfraCon. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;